import {Account as AccountApi} from '@shared/models/api_models';
import {SUPPORTED_LANGUAGES, SupportedLanguage, getLanguageByCode} from '@shared/models/language';

import {createDataStore} from '@shared_web/lib/data_store';

export type Account = AccountApi & {language: SupportedLanguage};

const accountStore = createDataStore<Account | undefined>();

export const setAccount = accountStore.setData;
export const useAccount = accountStore.useData;
export const getAccount = accountStore.getData;
export const clearAccount = () => accountStore.setData(undefined);

export function getUserLanguage(account: Account | undefined): SupportedLanguage {
  return account?.language ?? detectUserLanguage();
}
export function getUserLocale(account: Account | undefined): string | undefined {
  return (SUPPORTED_LANGUAGES.find(l => l.name === account?.language) ?? SUPPORTED_LANGUAGES[0])
    .locale;
}

function detectUserLanguage(): SupportedLanguage {
  const code = navigator.language.split('-')[0];
  return getLanguageByCode(code) ?? SUPPORTED_LANGUAGES[0].name;
}

export const getLanguageCodeData = (language: string | undefined): string | undefined => {
  return SUPPORTED_LANGUAGES.find(l => l.name === language)?.locale;
};
